/**
 * @file
 */
import objectFitImages from 'object-fit-images';
import {calculateImageBrightness, sharePopup} from '../utils/Utils';

($ => {
  let ofiInitialized = false; // Needed for functions where you can't use .once()
  const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

  // AQ-59 quick fix.
  Drupal.behaviors.replaceText = {
    attach(context) {
      $('h2,h3', context).html((index, htmlstring) => {
        return htmlstring
          .replace(
            'waterzuiveringsinstallatie',
            'waterzuiverings&shy;installatie',
          )
          .replace('waterzuiveringsproces', 'waterzuiverings&shy;proces');
      });
    },
  };

  Drupal.behaviors.bodyClasses = {
    attach(context) {
      if (isIE11) {
        $('body', context).addClass('ie11');
      }
    },
  };

  Drupal.behaviors.objectfit = {
    attach() {
      const callOfi = () => {
        if (!ofiInitialized) {
          ofiInitialized = true;

          const $img = $('img');
          $img.each(() => {
            objectFitImages(this);
          })
        }
      };

      callOfi();
    },
  };

  Drupal.behaviors.initSelectric = {
    attach(context) {
      $('.selectrify', context).selectric({
        keys: {
          previous: [37, 38], // Left / Up
          next: [39, 40], // Right / Down
          select: [32, 13, 27], // Space / Enter / Escape
          open: [13, 32, 37, 38, 39, 40], // Enter / Space / Left / Up / Right / Down
          close: [9, 27] // Tab / Escape
        }
      });
    }
  };

  Drupal.behaviors.contentHeader = {
    attach(context) {
      if (!$('.content--header-background', context).length) {
        return false;
      }

      let imgUrl = $('.content--header-background').css('background-image');
      imgUrl = imgUrl
        .replace('url(', '')
        .replace(')', '')
        .replace(/"/gi, '');
      calculateImageBrightness(imgUrl, brightness => {
        if (brightness < 160) {
          $('.content--header-background').addClass('dark');
        } else {
          $('.content--header-background').addClass('light');
        }
      });
    },
  };

  Drupal.behaviors.videoAsset = {
    attach(context) {
      $('.component--video-link a', context).on('click', e => {
        $(e.currentTarget)
          .closest('.component--video-link')
          .fadeOut(1000);
        $(e.currentTarget)
          .closest('.component--video-content')
          .find('.component--video-iframe iframe')[0].src += '?autoplay=1';
        $(e.currentTarget).off('click');
        e.preventDefault();
      });
    },
  };

  Drupal.behaviors.inlineSVG = {
    attach(context) {
      /*
       * Replace all SVG images with inline SVG
       * to be able to use fill
       */
      $('img.svg', context).each((index, element) => {
        const $img = $(element);
        const imgID = $img.attr('id');
        const imgClass = $img.attr('class');
        const imgURL = $img.attr('src');

        $.get(
          imgURL,
          data => {
            // Get the SVG tag, ignore the rest.
            let $svg = $(data).find('svg');

            // Add replaced image's ID to the new SVG.
            if (typeof imgID !== 'undefined') {
              $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG.
            if (typeof imgClass !== 'undefined') {
              $svg = $svg.attr('class', `${imgClass} replaced-svg`);
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
            if (
              !$svg.attr('viewBox') &&
              $svg.attr('height') &&
              $svg.attr('width')
            ) {
              $svg.attr(
                'viewBox',
                `0 0 ${$svg.attr('height')} ${$svg.attr('width')}`,
              );
            }

            // Replace image with new SVG.
            $img.replaceWith($svg);
          },
          'xml',
        );
      });
    },
  };

  Drupal.behaviors.sharePopup = {
    attach(context) {
      $('.share-popup', context).on('click', e => {
        sharePopup(e);
      });
    },
  };

  Drupal.behaviors.blurFormLabels = {
    attach(context) {
      // Blur all text fields of forms.
      setTimeout(() => {
        const $inputs = $('form, .formitem', context).find('input[type=text]');
        if ($inputs.length > 0) {
          $inputs.each((index, element) => {
            $(element).blur();
          });
        }
      }, 0);
    },
  };

  Drupal.behaviors.mobileSearch = {
    attach(context) {
      const infomenuMobile = context.querySelector('.mobile-info-menu');
      if (infomenuMobile) {
        const searchbtn = infomenuMobile.querySelector('#global-search');
        searchbtn.addEventListener('click', () => {
          $('.searchButton').trigger('click');
        });
      }
    },
  };

  Drupal.behaviors.focuses = {
    attach(context) {

      // @TODO: This should be rewrited when working on next WCAG problems.

      // Remove outline.
      var $radio = $('.js-form-type-radio input', context);
      $radio.on('click', function () {
        $(this).addClass('mouse');
      });

      $radio.on('keyup', function (e) {
        if (e.keyCode === 9) {
          $(this).removeClass('mouse');
        }
      });

      var $checkbox = $('.js-form-type-checkbox input', context);
      $checkbox.on('click', function () {
        $(this).addClass('mouse');
      });

      $checkbox.on('keyup', function (e) {
        if (e.keyCode === 9) {
          $(this).removeClass('mouse');
        }
      });

      // On focus, add class to checkbox.
      var $checkbox = $('.js-form-type-checkbox', context);

      $checkbox.find('input').focus(function () {
        $(this).addClass('focused');
      }).blur(function () {
        $(this).removeClass('focused');
      });

      // Remove border on click link.
      var $a = $('a', context);
      $a.click(function () {
        $(this).css('border', 'none');
      });

      var $button = $('.button', context);
      $button.click(function () {
        $(this).css('border', 'none');
      });

      // Remove border on click filter item.
      var $filter = $('.filter-item', context);
      $filter.click(function () {
        $(this).css('border', 'none');
      });

      // Remove border on click input.
      var $input = $('input', context);
      $input.click(function () {
        $(this).css('outline', 'none');
      });

      // Toggle labels.
      $('.toggle--label', context).keyup(function(e) {
        if (e.keyCode === 13) {
          $(this).click();
        }
      });

      // Click button.
      $('.job--search-filter .submit', context).keyup(function(e) {
        if (e.keyCode === 13) {
          $('.job--search-filter .submit input', context).click();
        }
      });

      $('.job--search-filter .function', context).keyup(function(e) {
        if (e.keyCode === 9) {
          $('.job--search-filter .function fieldset .fieldset-wrapper').addClass('open');
        }
      });

      $('.job--search-filter .range', context).keyup(function(e) {
        if (e.keyCode === 13) {
          $('.job--search-filter .range select', context).click();
        }
      });

      $('.paragraph-dash_projectoverview', context).keyup(function(e) {
        if (e.keyCode === 9) {
          if (!$('.selectric-input').is(":focus")) {
            $(this).find('.selectric-wrapper').each(function(i, obj) {
              $(this).removeClass('selectric-open');
            });
          }
        }
      });

    },
  };

})(jQuery);

// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
// requestAnimationFrame polyfill by Erik M�ller
// fixes from Paul Irish and Tino Zijdel.
(() => {
  let lastTime = 0;
  const vendors = ['ms', 'moz', 'webkit', 'o'];
  for (let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[`${vendors[x]}RequestAnimationFrame`];
    window.cancelAnimationFrame =
      window[`${vendors[x]}CancelAnimationFrame`] ||
      window[`${vendors[x]}CancelRequestAnimationFrame`];
  }

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = callback => {
      const currTime = new Date().getTime();
      const timeToCall = Math.max(0, 16 - (currTime - lastTime));
      const id = window.setTimeout(() => {
        callback(currTime + timeToCall);
      }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }

  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = id => {
      clearTimeout(id);
    };
  }
})();
